import { useEffect, useMemo } from 'react';
import useCollaborationSidebarState from '../../../hooks/useCollaborationSidebarState';
export function useEmbeddedCommentPopover({
  iframeContainerID,
  popoverContentWrapperRef,
  closeEmbeddedCommentPopover
}) {
  const {
    commentableAreaClickCoordinates,
    isEmbeddedPopoverOpen,
    embeddedCommentCoordinates,
    embeddedPopoverAnchorSelector
  } = useCollaborationSidebarState();
  const dimensionsAndCoordinates = useMemo(() => {
    var _referenceElement;
    let referenceElement;
    if (embeddedPopoverAnchorSelector) {
      referenceElement = document.querySelector(embeddedPopoverAnchorSelector);
    } else if (iframeContainerID) {
      referenceElement = document.getElementById(iframeContainerID);
    }
    const referenceRect = (_referenceElement = referenceElement) === null || _referenceElement === void 0 ? void 0 : _referenceElement.getBoundingClientRect();
    if (isEmbeddedPopoverOpen) {
      return {
        top: referenceRect ? embeddedCommentCoordinates.top + referenceRect.top : embeddedCommentCoordinates.top,
        left: referenceRect ? embeddedCommentCoordinates.left + referenceRect.left : embeddedCommentCoordinates.left,
        width: embeddedCommentCoordinates.width,
        height: embeddedCommentCoordinates.height
      };
    } else {
      return {
        top: 0,
        left: 0,
        width: 0,
        height: 0
      };
    }
  }, [embeddedCommentCoordinates, isEmbeddedPopoverOpen, iframeContainerID, embeddedPopoverAnchorSelector]);
  useEffect(() => {
    var _popoverContentWrappe, _referenceElement2;
    if (!isEmbeddedPopoverOpen || !commentableAreaClickCoordinates) {
      return;
    }
    const popoverRect = (_popoverContentWrappe = popoverContentWrapperRef.current) === null || _popoverContentWrappe === void 0 ? void 0 : _popoverContentWrappe.getBoundingClientRect();
    let referenceElement;
    if (embeddedPopoverAnchorSelector) {
      referenceElement = document.querySelector(embeddedPopoverAnchorSelector);
    } else if (iframeContainerID) {
      referenceElement = document.getElementById(iframeContainerID);
    }
    const referenceRect = (_referenceElement2 = referenceElement) === null || _referenceElement2 === void 0 ? void 0 : _referenceElement2.getBoundingClientRect();
    const absoulteCoordinates = {
      x: commentableAreaClickCoordinates.x + ((referenceRect === null || referenceRect === void 0 ? void 0 : referenceRect.left) || 0),
      y: commentableAreaClickCoordinates.y + ((referenceRect === null || referenceRect === void 0 ? void 0 : referenceRect.top) || 0)
    };
    if (popoverRect && commentableAreaClickCoordinates) {
      if (absoulteCoordinates.x < popoverRect.left || absoulteCoordinates.x > popoverRect.right || absoulteCoordinates.y < popoverRect.top || absoulteCoordinates.y > popoverRect.bottom) {
        closeEmbeddedCommentPopover();
      }
    }
  }, [isEmbeddedPopoverOpen, commentableAreaClickCoordinates, closeEmbeddedCommentPopover, iframeContainerID, popoverContentWrapperRef, embeddedPopoverAnchorSelector]);
  return {
    dimensionsAndCoordinates
  };
}